'use client';

import { BookingCountryService } from '@repo/common/interfaces';
import { useLocale, useTranslations } from 'next-intl';
import ServiceActionCard from '../../ServiceActionCard/ServiceActionCard';
import { formatDuration, formatPrice } from '@repo/common/helpers';
import { VpIcon, VpIconButton } from '@vtmn-play/react';

import '../WidgetServiceCategoryItem.scss';

interface WidgetServiceItemProps {
  onClick: () => void;
  countryService: BookingCountryService;
  showPrice?: boolean;
}

const WidgetServiceItem = ({
  onClick,
  countryService,
  showPrice = true,
}: WidgetServiceItemProps) => {
  const locale = useLocale();
  const t = useTranslations('Widget.pages.steps.services.content.card');
  const tServiceCard = useTranslations('Generic.service.card');

  return (
    <ServiceActionCard
      action={
        <VpIconButton
          className='widget-service-item-selection'
          onClick={onClick}
          size='small'
          type='button'
          variant='tertiary'
        >
          <VpIcon className='rtl-swap' name='chevron-right' size={20} />
          <span className='sr-only'>{t('buttons.select')}</span>
        </VpIconButton>
      }
      as='div'
      className='widget-service-item'
      description={countryService?.productSheet?.description ?? undefined}
      duration={formatDuration(countryService?.productSheet?.duration)}
      i18n={{ showDescription: tServiceCard('details') }}
      id={countryService.sku}
      imageSrc={countryService?.productSheet?.image ?? undefined}
      name={countryService?.productSheet?.name ?? ''}
      price={
        showPrice
          ? formatPrice(tServiceCard('price'), locale, countryService?.offer)
          : undefined
      }
    />
  );
};

export default WidgetServiceItem;
